import NProgress from 'nprogress';

export const start = () => NProgress.start();
export const done = () => NProgress.done();

const exported = { start, done };
export default exported;
